export default __webpack_public_path__ + "static/media/J_wdt_c_cap_2.1241eff8.mp3";